import React, { useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { HiOutlineChevronDoubleDown } from "react-icons/hi2";
import { NavLink, useLocation } from "react-router-dom";

const NestedSideButton = ({ index, items }) => {
  const [display, setDisplay] = useState(false);
  const location = useLocation();
  const phone = false;
  const handleDisplay = () => {
    setDisplay(!display);
  };
  // match url with route url to check for current url and set active class
  const activeLink =
    items.subUrl[0]?.url.split("/")[0] === location.pathname.split("/")[1];

  return (
    <div className="transition-all duration-300">
      <button
        className={
          phone
            ? ""
            : `${
                activeLink
                  ? "text-secondary"
                  : "text-darkPrimary dark:text-white"
              } w-full py-3 hover:text-secondary dark:hover:text-secondary dark:opacity-80 text-sm cxl:text-base my-0 flex items-center gap-4 whitespace-nowrap rounded-lg px-4 font-semibold capitalize transition-colors flex-row duration-100`
        }
        key={index}
        onClick={handleDisplay}
      >
        <span className="text-xl">{items.icon}</span>
        <span>{items.title}</span>
        <span className="ml-auto">
          {!display ? <FiChevronRight /> : <HiOutlineChevronDoubleDown />}{" "}
        </span>
      </button>
      {/* Sliding sub navigation */}
      <ul
        tabIndex={0}
        className={`${
          display ? "max-h-[15rem]" : "max-h-0"
        } text-white uppercase w-full pl-6 pr-4 transition-[max-height] duration-200 border-b dark:border-gray-700 border-gray-300 border-dashed overflow-hidden ease-linear`}
      >
        {items?.subUrl?.map((item, idx) =>
          item.subUrl?.length ? (
            //   <MultiNestedSideButton key={idx} index={idx} items={item} />
            "multi"
          ) : (
            <NavLink
              end
              key={idx}
              to={item.url}
              className="w-full py-3 hover:text-secondary dark:text-white dark:hover:text-secondary dark:opacity-80 text-sm cxl:text-base my-0 flex items-center gap-4 whitespace-nowrap px-0 font-medium text-gray-600 capitalize transition-colors flex-row duration-100 border-l border-secondary relative group"
            >
              <span className="group-hover:opacity-100 opacity-0 transition-all duration-100 absolute w-2 h-2 bg-secondary rounded-full -translate-x-1/2"></span>
              <span className="pl-[1.6rem]">{item.title}</span>
            </NavLink>
          )
        )}
      </ul>
    </div>
  );
};

export default NestedSideButton;
